import { render } from "./floatInp.vue?vue&type=template&id=4aba5be7"
import script from "./floatInp.vue?vue&type=script&lang=js"
export * from "./floatInp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__